import { useState } from "react";

const DeleteModal = ({ show, onClose, onConfirm, message, isLoading }) => {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    onClose();
    setClosing(false);
  };

  return (
    show && (
      <>
        <style>
          {`
          @keyframes slideDown {
            0% { transform: translateY(-20px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }

          @keyframes slideUp {
            0% { transform: translateY(0); opacity: 1; }
            100% { transform: translateY(-20px); opacity: 0; }
          }

          .slide-down {
            animation: slideDown 0.25s ease-out forwards;
          }

          .slide-up {
            animation: slideUp 0.25s ease-in forwards;
          }

          /* Add these override styles */
          .modal-override {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            bottom: 0 !important;
            z-index: 1050 !important;
            background-color: rgba(0, 0, 0, 0.3) !important;
          }

          .modal-override .modal-dialog {
            margin-top: 5vh !important;
            margin-bottom: 5vh !important;
            background-color: transparent !important;
          }

          .modal-override .custom-modal-content {
            background: #ffffff !important;
            border-radius: 12px !important;
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
            padding: 10px 0px 20px 0px !important;
          }

          .btn-cancel {
            background-color: #fff !important;
            color: var(--bs-primary) !important;
            border: 1px solid var(--bs-primary) !important;
            transition: all 0.3s ease !important;
          }

          .btn-cancel:hover {
            background-color: var(--bs-primary) !important;
            color: #fff !important;
          }

          .btn-delete {
            background-color: #dc3545 !important;
            color: #fff !important;
            border: 1px solid #dc3545 !important;
            transition: all 0.3s ease !important;
          }

          .btn-delete:hover {
            background-color: #b02a37 !important;
            color: #fff !important;
          }

          .exclamation-icon {
            font-size: 3rem !important;
            color: #dc3545 !important;
          }
        `}
        </style>

        <div className="modal-override modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div
              className={`modal-content custom-modal-content border-0 ${closing ? "slide-up" : "slide-down"
                }`}
            >
              <div className="modal-body text-center">
                <div className="mb-3">
                  <i className="bi bi-exclamation-circle-fill exclamation-icon"></i>
                </div>
                <p className="fs-6 text-dark mb-1">
                  {message || (
                    <>
                      Are you sure you want to permanently delete this role?
                    </>
                  )}
                </p>
                <p className="text-muted small">
                  This action cannot be undone.
                </p>
              </div>

              <div className="modal-footer border-0 d-flex justify-content-center gap-3">
                <button className="btn btn-cancel px-4 rounded" disabled={isLoading} onClick={handleClose}>
                  No, Cancel
                </button>
                <button className="btn btn-delete px-4 rounded" disabled={isLoading} onClick={onConfirm}>

                  {isLoading ? <><div className="spinner-border spinner-border-sm" role="status" />{" "}Deleting...</> : " Yes, Delete"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default DeleteModal;